import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { TooltipModule } from '@intranet/components/tooltip/tooltip.module';
import { AvatarModule } from '@intranet/components/avatar';
import { FormsModule } from '@angular/forms';
import { UserPickerModule } from '@intranet/components/user-picker';

import { PlannerComponent } from './planner.component';
import { PlannerNavPickerComponent } from './planner-nav-picker/planner-nav-picker.component';
import { PlannerLogTimerowComponent } from './planner-log-timerow/planner-log-timerow.component';
import { PlannerDatePickerComponent } from './planner-date-picker/planner-date-picker.component';
import { AddToPlannerDialogComponent } from './add-to-planner-dialog/add-to-planner-dialog.component';
import { PlannedBlockDialogComponent } from './planned-block-dialog/planned-block-dialog.component';
import { PlannedBlocksListDialogComponent } from './planned-blocks-list-dialog/planned-blocks-list-dialog.component';
import { PlannedFlagComponent } from './planned-flag/planned-flag.component';

// A fresh, independent plugin registration — separate from (and doesn't
// import) TimerModule's own FullCalendarModule.registerPlugins call, so
// this feature has no dependency on the Timer module. Calling this again
// with the same plugins is safe/idempotent — FullCalendar is designed to
// support each lazy-loaded feature registering what it needs.
FullCalendarModule.registerPlugins([
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin,
]);

@NgModule({
    declarations: [
        PlannerComponent,
        PlannerNavPickerComponent,
        PlannerLogTimerowComponent,
        PlannerDatePickerComponent,
        AddToPlannerDialogComponent,
        PlannedBlockDialogComponent,
        PlannedBlocksListDialogComponent,
        PlannedFlagComponent,
    ],
    imports: [CommonModule, FormsModule, DragDropModule, FullCalendarModule, TooltipModule, AvatarModule, UserPickerModule],
    // AddToPlannerDialogComponent / PlannedBlocksListDialogComponent: opened
    // from the Actions list's ⋮ menu. PlannedFlagComponent: on the list's
    // rows and the board's cards.
    exports: [PlannerComponent, AddToPlannerDialogComponent, PlannedBlocksListDialogComponent, PlannedFlagComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlannerModule {}
